<template>
  <el-container class="editor-container">
    <!-- 编辑器 -->
    <el-main class="editor">
      <div class="editor-panel">
        <div class="panel-header">
          <span class="panel-title">编辑器</span>
        </div>
        <div class="panel-content">
          <vue-tinymce
            id="editor-id"
            v-model="form.content"
            @change="contentChange"
            :setting="setting"></vue-tinymce>
        </div>
      </div>
    </el-main>

    <!-- 预览区域 -->
    <el-aside class="preview-wrapper">
      <div class="preview-panel">
        <div class="panel-header">
          <span class="panel-title">内容预览</span>
        </div>
        <div class="panel-content preview-content" v-html="form.content"></div>
      </div>
    </el-aside>
  </el-container>
</template>

<script>
export default {
  name: 'EditorPreview',
  props: {
    content: {
      type: String,
      default: '',
    },
    moduleName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        content: '',
      },
      setting: {
        forced_root_block: '',  // 禁止自动包装<p>
        force_br_newlines: true,
        force_p_newlines: false,
        image_dimensions: false,
        valid_elements: '*[*]', // 允许所有元素和属性
        content_style: `
          p { margin: 0 !important; padding: 0 !important; }
          span { color: inherit !important; }
          img { max-width: 100% !important; height: auto !important; }
        `,
        menubar: 'edit view insert format tools',
        plugins:
          ' link lists image code table colorpicker textcolor wordcount contextmenu media preview',
        toolbar:
          'bold italic underline | styleselect | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | undo redo | link unlink image media | removeformat preview',
        style_formats: [
          {
            title: '行高',
            items: [
              { title: '1', block: 'p', styles: { 'line-height': '1.0' } },
              { title: '1.5', block: 'p', styles: { 'line-height': '1.5' } },
              { title: '2', block: 'p', styles: { 'line-height': '2' } },
              { title: '2.5', block: 'p', styles: { 'line-height': '2.5' } },
              { title: '3', block: 'p', styles: { 'line-height': '3' } },
              { title: '3.5', block: 'p', styles: { 'line-height': '3.5' } },
              { title: '4', block: 'p', styles: { 'line-height': '4' } },
            ],
          },
        ],
        // 配置自动高度（新增配置项）
        // autoresize_bottom_margin: 20,
        // autoresize_on_init: true,
        min_height: 800,  // 最小高度
        max_height: 800,  // 最大高度（按需设置）

        style_formats_merge: true,
        style_formats_autohide: true,
        file_picker_types: 'media',
        file_picker_callback: async (cb, value, meta) => {
          if (meta.filetype === 'media') {
            let input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.onchange = async () => {
              let file = input.files[0];
              let formData = new FormData();
              formData.append('upload', file);
              let res = await this.$api.rUpload('file/upload/video', formData);
              if (res.status === 1) {
                cb(res.data.url, { title: file.name });
                input.remove();
              }
            };
            input.click();
          }
        },
        images_upload_handler: async (blobInfo, success, failure) => {
          let res = await this.$api.rPost('file/upload/base64image', {
            file: blobInfo.base64(),
            module: this.moduleName,
          });
          if (res.status === 1) {
            success(res.data.url);
            const editor = tinymce.activeEditor;
            if (editor) {
              const content = editor.getContent();
              const updatedContent = content.replace(
                new RegExp(blobInfo.blobUri(), 'g'),
                res.data.url
              );
              editor.setContent(updatedContent);
              this.$emit('success', updatedContent);
            }
          } else {
            failure('图片上传失败');
          }
        },
        language_url: this.$util.img('/upload/langs/zh-Hans.js'),
        language: 'zh-Hans',
        height: 500,
        uploadUrl: '',
      },
    };
  },
  mounted() {
    this.uploadUrl = this.$util.img('/api/school/file/upload/image');
    this.form.content = this.content;
  },
  methods: {
    contentChange() {
      this.$emit('success', this.form.content);
    },
  },
};
</script>

<style lang="scss">
.editor-container {
  display: flex;
  gap: 12px;
  padding: 12px;
  background-color: #f5f7fa;
  height: calc(100vh - 380px);
}

.editor-panel,
.preview-panel {
  height: 100%;
  background: white;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .panel-header {
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
    background-color: #FFFFFF;
    .panel-title {
      font-weight: 600;
      color: #1f2d3d;
      font-size: 14px;
    }
  }

  .panel-content {
    flex: 1;
    overflow: hidden;
    position: relative;
  }
}

.editor {
  padding: 0;
  flex: 1;

  ::v-deep .tox-tinymce {
    border: none !important;
    border-radius: 0 0 8px 8px !important;
  }
}

.preview-wrapper {
  width: 400px;
  flex-shrink: 0;

  .preview-content {
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    ::v-deep {
      p, div, span {
        white-space: pre-wrap !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        hyphens: auto !important;
        text-indent: 2em;
        text-align: justify !important;
        line-height: 1.8 !important;
      }
      * {
        word-break: break-all;
        overflow-wrap: anywhere;
      }
      li {
        word-break: normal;
      }
      table {
        table-layout: fixed;
        width: 100% !important;
        td, th {
          word-break: break-word;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EditorPreview.vue